/* ++++++++++ --------------- EXPORT : HUBSPOT MODAL : STYLES --------------- ++++++++++ */
export default theme => ({
  portedtobeta: {
    height: '100%'
  }
});
